import { RouteConfig } from '../types';
import * as Components from '../lazyComponents';
import { Navigate } from 'react-router-dom';

export const brokerRoutes: RouteConfig[] = [
  {
    path: '/broker/dashboard',
    element: <Components.BrokerDashboardPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/propiedades',
    element: <Components.SharedPropertiesPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/propiedades/agregar',
    element: <Components.CreatePropertyPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/agentes',
    element: <Components.SharedAgentsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/equipo',
    element: <Components.SharedAgentsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/clientes',
    element: <Navigate to="/broker/leads" replace />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/leads',
    element: <Components.BrokerClientsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/clientes/nuevo',
    element: <Navigate to="/broker/leads/nuevo" replace />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/leads/nuevo',
    element: <Components.CreateClientPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/leads/papelera',
    element: <Components.ClientsTrashPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/agenda',
    element: <Components.BrokerAgendaPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/documentos',
    element: <Components.BrokerDocumentsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/comisiones',
    element: <Components.BrokerCommissionsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/comisiones/aprobacion',
    element: <Components.BrokerCommissionApprovalPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/reportes',
    element: <Components.BrokerReportsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/configuracion',
    element: <Components.BrokerSettingsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/configuracion/planes',
    element: <Components.BrokerPlansPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
  {
    path: '/broker/objetivos',
    element: <Components.BrokerGoalsPage />,
    roles: ['BROKER_MANAGER_ADMIN'],
    requiresAuth: true,
    requiresLayout: true,
  },
];
